import { IViewChargeHistoryResponse } from '../../models/responses/oms';

export const mockViewChargeHistoryResponse: IViewChargeHistoryResponse = {
  customerAccountId: '03ED1FF627BF28000S',
  userId: '0513E211CECBD2CE0U',
  orderNumber: 'WG79943169',
  salesDate: '2024-09-02',
  storeNumber: 8119,
  transactionId: 95619,
  registerNumber: 54,
  subTotal: '300.00',
  deliveryFees: 'FREE',
  pickUpFees: 'FREE',
  proExtraSavings: '-10.00',
  preTaxTotal: '290.00',
  POJobName: 'PO123456',
  projectName: 'Project Alpha',
  salesTax: '17.40',
  originalOrderTotal: '307.40',
  refundTotal: '-20.00',
  adjustedOrderTotal: '307.40',
  transactions: [
    {
      transactionType: 'Sale',
      transactionDescription: 'Charged at Checkout',
      transactionDate: '2025-11-28',
      transactionAmount: '100',
      itemTotal: '180',
      tenders: [
        {
          value: '7951',
          type: 'VI',
          amount: '2.48',
        },
      ],
      lineItems: [
        {
          omsId: 204274131,
          skuNumber: 307319,
          quantity: 0,
          unitPrice: 1.38,
          itemDescFromPOS: "Spinach Baby's Leaf Hybrid Seed",
          itemDescFromCatalog: "Spinach Baby's Leaf Hybrid Vegetable Seed",
          imageUrl:
            'https://images.thdstatic.com/productImages/afa11a68-283c-43e7-8a11-c597bd0862b5/svn/hex-nuts-800051-64_100.jpg',
        },
      ],
    },
    {
      transactionType: 'Cancellation',
      transactionDescription: 'Cancelled',
      transactionDate: '2025-11-28',
      transactionAmount: '100',
      itemTotal: '180',
      tenders: [
        {
          value: '7951',
          type: 'VI',
          amount: '2.48',
        },
      ],
      lineItems: [
        {
          omsId: 204274131,
          skuNumber: 307319,
          quantity: 0,
          unitPrice: 1.38,
          itemDescFromPOS: "Spinach Baby's Leaf Hybrid Seed",
          itemDescFromCatalog: "Spinach Baby's Leaf Hybrid Vegetable Seed",
          imageUrl:
            'https://images.thdstatic.com/productImages/afa11a68-283c-43e7-8a11-c597bd0862b5/svn/hex-nuts-800051-64_100.jpg',
        },
        {
          omsId: 204274131,
          skuNumber: 1234234,
          quantity: 3,
          unitPrice: 4.0,
          itemDescFromPOS: "Spinach Baby's Leaf Hybrid Seed",
          itemDescFromCatalog: "Spinach Baby's Leaf Hybrid Vegetable Seed",
          imageUrl:
            'https://images.thdstatic.com/productImages/afa11a68-283c-43e7-8a11-c597bd0862b5/svn/hex-nuts-800051-64_100.jpg',
        },
      ],
    },
    {
      transactionType: 'Cancellation',
      transactionDescription: 'Cancelled',
      transactionDate: '2025-11-28',
      transactionAmount: '100',
      itemTotal: '180',
      tenders: [
        {
          value: '7951',
          type: 'VI',
          amount: '2.48',
        },
      ],
      lineItems: [
        {
          omsId: 204274131,
          skuNumber: 307319,
          quantity: 0,
          unitPrice: 1.38,
          imageUrl:
            'https://images.thdstatic.com/productImages/afa11a68-283c-43e7-8a11-c597bd0862b5/svn/hex-nuts-800051-64_100.jpg',
        },
      ],
    },
  ],
};
